import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

export const DashboardOutlet = () => {
  return (
    <Box height="100%">
      <Outlet />
    </Box>
  );
};
